import { useMutation } from "@tanstack/react-query";
import { downloadVacancies } from "../api/vacancyApi";

// Acción imperativa: descarga el Excel de vacantes. La UI arma el archivo en onSuccess.
export const useDownloadVacancies = () =>
  useMutation({ mutationFn: downloadVacancies });
